module.exports = __webpack_public_path__ + "login-background.64c8e79c6d51afb7f2f4.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/src/assets/images/login-background.jpg
// module id = ../../../../../src/assets/images/login-background.jpg
// module chunks = styles